<!-- landing-page.component.html -->
<div
  class="my-10 mx-auto container text-white font-sans pt-0 px-6 md:px-12 lg:px-20 lg:items-center"
>
  <div
    class="mx-auto flex flex-col lg:flex-row justify-between gap-[10] lg:items-center align-center"
  >
    <!-- Left Section -->

    <!-- MAIN GLASSY CONTAINER -->
    <div
      class="main-glassy-container w-full mx-auto relative z-10 flex flex-col xl:flex-row items-center xl:items-start justify-between gap-10 xl:gap-4 p-8 xl:p-12"
    >
      <!-- LEFT SECTION (HEADING & CONTROLS) -->
      <div
        class="left-section flex flex-col items-center xl:items-start gap-6 z-20 w-full xl:w-[650px]"
      >
        <h1 class="main-title text-center xl:text-left">
          Spin the Wheel of
          <span class="font-normal opacity-80 text-[#A6B1C2]">Fortune</span>
        </h1>
        <div class="title-divider"></div>

        <!-- CHOOSE VALUE GRID (DESKTOP ONLY / HIDDEN ON MOBILE) -->
        <div
          class="value-grid hidden md:flex flex-col gap-3 w-full max-w-[430px] mx-auto xl:mx-0"
        >
          <p class="section-subtitle text-center xl:text-left">
            Choose the Value of Your Spin 
          </p>
          <div class="grid-box grid grid-cols-4 gap-3 p-4 rounded-md">
            <button
              type="button"
              *ngFor="let amount of amountChoices; trackBy: trackByIndex"
              class="value-item rounded-md flex justify-center items-center transition-all"
            >
              {{ amount | currency: "USD" : "symbol" : "1.0-0" }}
            </button>
          </div>
        </div>

        <!-- SET VALUE INCREMENTER -->
        <div
          class="set-value-container flex flex-col gap-3 w-full max-w-[400px] mx-auto xl:mx-0"
        >
          <p class="section-subtitle text-center xl:text-left">
            Set the Value of Your Spin
          </p>
          <div
            class="incrementer-box flex justify-between items-center p-2 rounded-md"
          >
            <button
              class="incr-btn cursor-pointer disabled:opacity-50"
              (click)="decrementSpinAmount()"
            >
              -
            </button>
            <span class="font-semibold text-[22px] text-white">
              {{ spinAmount | currency: "USD" : "symbol" : "1.0-0" }}
            </span>
            <button
              class="incr-btn cursor-pointer disabled:opacity-50"
              (click)="incrementSpinAmount()"
            >
              +
            </button>
          </div>
        </div>

        <!-- SPIN NOW BUTTON -->
        <button
          class="button spin-now-btn w-full max-w-[373px] mx-auto xl:mx-0 transition-opacity hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
          (click)="openLoginModal()"
        >
          Spin Now!
        </button>

        <!-- Eligibility Alerts (Conditional from previous logic) -->
        <!-- @if(!fresspinWindowIsOpen){
      <p class="text-xs text-gray-300 mt-2 text-center xl:text-left">
        Eligibility Update: <span class="text-teal-400 cursor-pointer underline" (click)="RedirectToWallet()">Deposit
          now</span> to unlock!
      </p>
      } @else if(freeSpinAvailable){
      <p class="text-xs text-green-400 mt-2 font-semibold text-center xl:text-left">
        🎉 Your Free Spin is Ready!
      </p>
      } -->
      </div>

      <!-- Right Section (Dummy Spinner Component) -->
      <div class="relative flex justify-center lg:justify-end py-6">
        <div class="relative">
          <img loading="lazy"
            (click)="openLoginModal()"
            src="/Images/spinner.png"
            alt="Spinner Preview"
            class="spinner-image w-[350px] sm:w-[450px] lg:w-[600px] xl:w-[700px]"
          />
        </div>
      </div>
      <!-- END MAIN GLASSY CONTAINER -->

      <!-- <div class="bg-[#0A0E1F] flex justify-center lg:justify-end">
      <img loading="lazy" src="/Images/Spinner/spinner-home.png" class="spinner-image">
      <app-spinners [showHeader]="false"></app-spinners>
    </div> -->
    </div>
  </div>
</div>
